import GenericTemplate from '_templates/GenericTemplate';
import {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Divider} from '@mui/material';

import {MainPanel} from './MainPanel';
import {SearchPanel} from './SearchPanel';
import {SearchConditions} from './types';

export const InspectionResultsPage = () => {
  const {t} = useTranslation();

  //確定条件
  const [fixSearchConditions, setFixSearchConditions] = useState<SearchConditions | null>(null);

  /**
   * 検索処理
   */
  const handleSearch = useCallback((searchConditions: SearchConditions) => {
    //検索条件FIX
    setFixSearchConditions({...searchConditions}); //同じ条件で再検索できるように新しいオブジェクトにして入れる
  }, []);

  const title = 'menu.page_name.検査結果検索';

  return (
    <GenericTemplate title={`${t(title)}`}>
      <SearchPanel onSearch={handleSearch} />
      <Divider sx={{margin: '0.5em 0'}} />
      <MainPanel searchConditions={fixSearchConditions} />
    </GenericTemplate>
  );
};
